import { db } from '@/firebase.js'
export default({
  state:{
    items: [],
    actualCategory: [],
    showModal: false
  },
  mutations:{
    queryData(state, data){
      db.collection(data).get().then(querySnapshot=>{
        querySnapshot.forEach(doc=>{
          let url = doc.data().url;
          let name = doc.data().name;
          state.items.push({
            name,
            url
          })
        })
      })
    },
    fullCategory(state, data){
      state.showModal = !state.showModal;
      state.actualCategory = data;
    }
  },
  actions:{
    queryData({ commit }, payload){
      commit('queryData', payload)
    },
    fullCategory({commit}, payload){
      commit('fullCategory', payload)
    }
  },
  getters:{}
})


// bindRealisationsBest(state){
//   db.collection('realisations_best').get().then(querySnapshot=>{
//       querySnapshot.forEach(doc=>{
//           let url = doc.data().url;
//           let name = doc.data().name;
//           let date = doc.data().date
//           state.realisationsBest.push({
//               name,
//               url,
//               date
//           })
//       })
//   })
// },